export class Error {

    mensaje: string = "";

}
